export default "__VITE_ASSET__DIFDcg6x__"